// extracted by mini-css-extract-plugin
export default {"root":"vKalC","myMessage":"TPpjY","firstInGroup":"iwvYJ","lastInGroup":"MuU4D","mobile":"IczST","smallMobile":"hP8Ad","imageAccessible":"MrsKL","image":"PM_b1"};